// slice

import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer, PERSIST, PURGE } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import homeReducer from './slices/home';
import loadingReducer from './slices/loading';
import messageReducer from './slices/message';
import modalReducer from './slices/modal';
import noticeReducer from './slices/notice';
import notificationReducer from './slices/notification';
import settingsReducer from './slices/settings';
import userReducer from './slices/user';

const persistConfig = {
  key: 'root',
  storage
};

const rootReducer = combineReducers({
  user: userReducer,
  home: homeReducer,
  notice: noticeReducer,
  modal: modalReducer,
  loading: loadingReducer,
  message: messageReducer,
  settings: settingsReducer,
  notification: notificationReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [PERSIST, PURGE]
      }
    })
});

export const persistor = persistStore(store);
export default store;
